import { render, staticRenderFns } from "./my_table.vue?vue&type=template&id=6e38ddb7&scoped=true&"
import script from "./my_table.vue?vue&type=script&lang=js&"
export * from "./my_table.vue?vue&type=script&lang=js&"
import style0 from "./my_table.vue?vue&type=style&index=0&id=6e38ddb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e38ddb7",
  null
  
)

export default component.exports